export const USER_STATUS = {
  ACTIVE: 'active',
}
